import { AUTH_STATUS, AUTH_ACTIONS } from "constants";

const DEFAULT_STATE = AUTH_STATUS.UNAUTHORIZED;

export default (state = DEFAULT_STATE, { type }) => {
    switch (type) {
    case AUTH_ACTIONS.AUTHENTICATE:
        return AUTH_STATUS.AUTHORIZING;
    case AUTH_ACTIONS.AUTHENTICATED:
        return AUTH_STATUS.AUTHORIZED;
    case AUTH_ACTIONS.FAILED_AUTHENTICATE:
        return AUTH_STATUS.AUTHORIZATION_FAILED;
    default:
        return state;
    }
};
